





































import { Component, Prop, Vue } from "vue-property-decorator";
import { Settings, TenantSettings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import { LocalStorage } from "@/shared/core/localStorage";
import { CustomerHelper } from "@/shared/crm/helpers/customerHelper";
import store from "@/shared/core/store";
import { GuidelineApi, DayDone } from "@/shared/components/guidelines/guidelineApi";
import { TreatmentApi, AsNeededSlot } from "@/shared/components/treatments/treatmentApi";
import CzCard from "@/shared/components/cz/CzCard.vue";
import CzGlow from "@/shared/components/cz/CzGlow.vue";
import CzListRow from "@/shared/components/cz/CzListRow.vue";
import CzButton from "@/shared/components/cz/CzButton.vue";

// The account menu (approved menu, 22-10): the ways in from the parent, then the customer's own things and "My account".
@Component({ components: { CzCard, CzGlow, CzListRow, CzButton } })
export default class AccountMenu extends Vue {
  @Prop({ type: Boolean, default: false }) inline!: boolean;

  settings: TenantSettings = {};
  hasPrograms: boolean = false;
  hasCourses: boolean = false;
  hasReports: boolean = false;
  hasGuidelines: boolean = false;
  hasTreatment: boolean = false;
  guidelines: any[] = [];
  todayPending: number = 0;
  surveysPending: number = 0;

  get initial(): string {
    return (this.firstName || "·").charAt(0).toUpperCase();
  }

  get todayBadge(): string {
    return this.todayPending > 0 ? this.$t("{0} for today").toString().replace("{0}", String(this.todayPending)) : "";
  }

  get hasPlan(): boolean {
    return this.hasPrograms || this.guidelines.length > 0 || this.hasTreatment;
  }

  get accountBadge(): string {
    return this.surveysPending > 0 ? String(this.surveysPending) : "";
  }

  get isLoggedIn() {
    return store.state.loggedIn === true;
  }

  get firstName(): string {
    return CustomerHelper.getStoredFirstName();
  }

  // CodeScanner registration of the dynamic keys below:
  // $t("Good morning") $t("Good afternoon") $t("Good evening")
  get greetingKey(): string {
    const hour = new Date().getHours();
    if (hour < 12) {
      return "Good morning";
    }
    if (hour < 20) {
      return "Good afternoon";
    }
    return "Good evening";
  }

  async mounted() {
    this.settings = store.state.settings;
    if (this.isLoggedIn) {
      this.hasPrograms = await this.anyProgram(`customer/${CustomerHelper.getStoredCustomer()}`);
      const reports = await new CrudService().httpGet(
        `${Settings.HostName}/api/publicreports/customer/${CustomerHelper.getStoredCustomer()}`,
      );
      this.hasReports = reports != null && reports.ok === true && reports.data.length > 0;
      const courses = await new CrudService().httpGet(`${Settings.HostName}/api/public-courses/my-courses`);
      this.hasCourses = courses != null && courses.ok === true && courses.data.length > 0;
      const guidelines = await GuidelineApi.list();
      this.guidelines = guidelines != null && guidelines.ok === true ? guidelines.data : [];
      this.hasGuidelines = this.guidelines.length > 0;
      this.todayPending = this.hasGuidelines ? guidelines.data.filter((g: any) => g.todayStatus !== DayDone).length : 0;
      const treatment = await TreatmentApi.today();
      const takes = treatment != null && treatment.ok === true ? treatment.model.rows : [];
      this.hasTreatment = takes.length > 0 || (treatment != null && treatment.ok === true && treatment.model.hasTreatment === true);
      this.hasGuidelines = this.hasGuidelines || takes.length > 0 || (this.hasTreatment && await this.anyUnscheduled());
      this.todayPending += takes.filter((r: any) => r.slot !== AsNeededSlot && !r.items.every((i: any) => i.taken)).length;
      this.$emit("entries", { today: this.hasGuidelines, plan: this.hasPlan });
      const surveys = await new CrudService().httpGet(`${Settings.HostName}/api/publiccustomersurveys/customer-surveys/${CustomerHelper.getStoredCustomer()}`);
      this.surveysPending = Array.isArray(surveys) ? surveys.filter((x: any) => x.answeredDate === null && x.token).length : 0;
    }
  }

  // Only what is active shows in Today; an unknown answer keeps the entry so no treatment is left without a way in.
  async anyUnscheduled(): Promise<boolean> {
    const detail = await TreatmentApi.detail().catch(() => null);
    return detail == null || detail.ok !== true || TreatmentApi.unscheduled(detail.model.lines).length > 0;
  }

  async anyProgram(path: string): Promise<boolean> {
    const data = await new CrudService().httpGet(
      `${Settings.HostName}/api/publicprogrampacks/${path}`,
    );
    return data != null && data.ok === true && data.data.length > 0;
  }

  close() {
    this.$emit("close");
  }

  openLogin(register: boolean) {
    LocalStorage.add("loginModeOn", register);
    this.close();
    store.commit("openLogin");
  }

}
